import { IUCHeroGalleryItem } from '@shared/components/@organisms/UCHeroGallery/types';

import { ISBHeroGalleryItem } from './types';

export const transformUCHeroGalleryItem = (hero: ISBHeroGalleryItem): IUCHeroGalleryItem => {
  return {
    id: hero._uid,
    bannerImage: {
      src: hero.desktop_image?.filename ?? '',
      alt: hero.desktop_image?.alt ?? '',
    },
    bannerImageMobile: {
      src: hero.mobile_image?.filename ?? '',
      alt: hero.mobile_image?.alt ?? '',
    },
    link: hero.link.cached_url ?? hero.link.url ?? undefined,
  };
};
